import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DomainService } from "../../services/domain.service";
import { DomainRegisterDateDTO, PersonalTrustedDomains } from "../../models/shared.model";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-trusted-domains",
  templateUrl: "./trusted-domains.component.html",
  styleUrl: "./trusted-domains.component.css"
})
export class TrustedDomainsComponent implements OnInit {
  trustedDomains: PersonalTrustedDomains;
  isLoading: boolean = false;
  untrustingDomain: DomainRegisterDateDTO | null = null;

  constructor(
    private domainService: DomainService,
    private translate: TranslateService,
    private toastrService: ToastrService
  ) {
    this.loadTrustedDomains();

    this.domainService.reloadPersonalTrustedList.subscribe(value => {
      if (value)
        this.loadTrustedDomains();
    })
  }

  ngOnInit(): void {

  }

  loadTrustedDomains() {
    this.trustedDomains = this.domainService.loadPersonalTrustedListFromCache();
  }

  untrust(domainName: string, domain: DomainRegisterDateDTO, isDomain: boolean) {
    this.untrustingDomain = domain;
    this.domainService.untrustDomain(domainName, isDomain).then(() => {
      this.loadTrustedDomains();
      this.domainService.reloadPersonalTrustedList.next(true);
      this.untrustingDomain = null;
      this.toastrService.success(this.translate.instant('trusted_domains.success_to_untrust', {domain: domainName}));
    }).catch((error) => {
      console.error(error);

      this.toastrService.error(this.translate.instant("trusted_domains.untrusted_failed", { domain: domainName }));
      this.untrustingDomain = null;
    });
  }
}

